export enum RegistrationStage {
  PERSONALIZE = "personalize",
  APPLY = "apply",
}

export const LOGIN_REDIRECT_QUERY: string = "loginRedirect";

/** Checkout / deposit submit button copy — change here to update all registration apply steps that use it. */
export const CHECKOUT_SUBMIT_BUTTON_LABELS = {
  application: "Submit Application",
  registration: "Submit Registration",
} as const;

/** Payment schedule line labels on the Registration Review step (application fee row). */
export const REVIEW_PAYMENT_SCHEDULE_FEE_LABELS = {
  totalPaid: "Total Paid",
  dueToday: "Due Today",
} as const;

export const POSSIBLE_STEP_NAMES = {
  accountCreation: "Account Creation",
  aboutYou: "About You",
  learnerInformation: "Learner Information",
  groupVisa: "Group Visa",
  review: "Review",
  reviewAndSubmit: "Review And Submit",
  checkout: "Checkout", // when student pays app fee
  submitInstitution: "Submit", // when institution pays app fee
  nextSteps: "Next Steps",
} as const;
